import { render, staticRenderFns } from "./BridgeAddUpdate.vue?vue&type=template&id=125cfcfe"
import script from "./BridgeAddUpdate.vue?vue&type=script&lang=js"
export * from "./BridgeAddUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports